var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBackground(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 429,
    viewBox: "0 0 1440 429",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M134.536 231.006H134.559C242.817 234.319 437.162 237.977 568.522 227.26C759.247 211.699 845.076 171.56 910.361 171.56C925.245 171.86 940.111 173.807 954.893 177.391",
    stroke: "#E6E6E6",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M795.556 183.565H795.523C759.784 190.934 717.956 201.475 659.045 210.638C630.498 215.206 600.78 218.95 569 221.707C533.429 224.95 497.534 226.162 460.143 226.966C414.848 227.906 368.047 229.906 323.577 231.055C322.975 231.055 322.383 231.055 321.777 231.078H321.743C308.953 231.194 295.868 231.309 282.818 231.376C282.696 231.376 282.584 231.4 282.462 231.4C269.214 231.492 255.978 231.562 243.043 231.631H242.943C218.143 231.77 194.455 231.817 173.981 231.794H173.958",
    stroke: "#E6E6E6",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M772.404 181.246C772.402 181.24 772.4 181.236 772.397 181.233C772.394 181.229 772.391 181.228 772.387 181.228C772.384 181.228 772.381 181.229 772.378 181.233C772.375 181.236 772.372 181.24 772.37 181.246C739.307 186.758 704.784 196.242 650.623 205.266C623.036 210.043 596.385 213.647 569.466 216.173C534.463 219.664 503.552 220.238 471.326 220.787C431.885 221.385 391.763 224.876 353.404 227.54H353.291L348.251 227.885C338.026 228.251 326.908 228.666 315.367 229.079H315.333C291.82 229.929 266.48 230.846 243.041 231.627H242.94C232.614 231.972 222.668 232.322 213.413 232.591H213.394",
    stroke: "#E6E6E6",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.824 233.374H252.847C262.157 232.776 272.197 232.111 282.463 231.397C282.586 231.397 282.697 231.374 282.82 231.374C293.581 230.617 304.609 229.859 315.332 229.078H315.366C337.289 227.517 358.019 225.932 372.916 224.693C380.153 223.843 387.457 222.948 394.828 222.006C394.929 222.002 395.029 221.986 395.129 221.959C423.676 218.401 453.093 214.84 482.509 214.611C509.573 214.335 535.496 214.405 569.945 210.617C592.001 208.344 615.586 204.899 642.214 199.87C691.469 190.913 717.495 182.694 749.427 179.501H749.527",
    stroke: "#E6E6E6",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.259 234.168H292.276C329.721 230.329 379.35 224.922 397.597 221.523C428.405 215.783 460.682 208.418 493.696 208.418C526.71 208.418 557.514 210.058 633.804 194.495C704.056 180.164 701.529 172.088 818.68 186.248H818.692",
    stroke: "#E6E6E6",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00683594 203.155L3.46395 202.671H3.46958C29.0644 199.152 92.4207 191.219 143.787 191.219C209.801 191.219 301.502 201.042 324.236 201.042C346.97 201.042 366.788 193.677 396.862 193.677C479.018 193.677 470.951 182.196 553.109 182.196C598.294 182.196 628.173 186.162 655.795 189.732",
    stroke: "#E6E6E6",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1439.99 428.876H0",
    stroke: "#E6E6E6",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00390625 427.479C6.73251 426.712 421.931 425.903 433.228 423.021C448.753 419.062 934.028 413.713 956.795 413.713C979.561 413.713 1422.29 423.805 1439.99 419.366",
    stroke: "#E6E6E6",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00390625 426.082C13.46 424.553 410.707 422.931 433.302 417.172C464.351 409.254 911.281 398.55 956.814 398.55C1002.35 398.55 1404.59 418.733 1439.99 409.856",
    stroke: "#E6E6E6",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00585938 424.685C20.1894 422.389 399.483 419.959 433.373 411.318C479.955 399.44 888.534 383.388 956.834 383.388C1025.13 383.388 1386.88 413.662 1440 400.346",
    stroke: "#E6E6E6",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00585938 423.288C26.9169 420.225 388.258 416.986 433.445 405.466C495.553 389.629 865.787 368.225 956.852 368.225C1047.92 368.225 1369.18 408.591 1439.99 390.836",
    stroke: "#E6E6E6",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00585938 421.891C33.6432 418.064 377.032 414.014 433.517 399.616C511.152 379.82 843.038 353.065 956.865 353.065C1070.69 353.065 1351.47 403.522 1439.99 381.329",
    stroke: "#E6E6E6",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00585938 420.49C40.373 415.896 365.808 411.037 433.589 393.755C526.752 370 820.292 337.896 956.889 337.896C1093.49 337.896 1333.77 398.442 1439.99 371.812",
    stroke: "#E6E6E6",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00683594 419.097C47.1014 413.739 354.583 408.07 433.661 387.905C542.349 360.193 797.543 322.735 956.908 322.735C1116.27 322.735 1316.07 393.375 1439.99 362.304",
    stroke: "#E6E6E6",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00683594 417.698C53.8289 411.577 343.356 405.097 433.732 382.056C557.949 350.382 774.795 307.575 956.925 307.575C1139.05 307.575 1298.36 388.306 1440 352.796",
    stroke: "#E6E6E6",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00683594 416.303C60.5575 409.413 332.131 402.125 433.805 376.201C573.548 340.568 752.049 292.412 956.945 292.412C1161.84 292.412 1280.66 383.225 1439.99 343.284",
    stroke: "#E6E6E6",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00390625 201.864C0.00390625 201.864 291.963 270.67 412.269 270.67C532.575 270.67 826.733 239.543 1099.62 124.047C1372.5 8.55158 1439.99 2 1439.99 2",
    stroke: "#E6E6E6",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00390625 211.743C8.231 215.595 285.458 276.327 412.071 274.383C549.166 271.409 845.419 237.231 1100.31 134.567C1360.86 31.9061 1435.54 29.4758 1439.99 30.6225",
    stroke: "#E6E6E6",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00585938 221.625C16.46 229.331 278.96 282.605 411.874 278.092C565.767 272.866 864.106 234.909 1101.01 145.08C1349.22 55.2509 1431.1 56.9468 1440 59.2403",
    stroke: "#E6E6E6",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00585938 231.502C24.6871 243.057 272.458 288.346 411.675 281.792C582.362 273.755 882.791 232.586 1101.7 155.586C1337.58 78.5915 1426.64 84.411 1440 87.8466",
    stroke: "#E6E6E6",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00585938 241.383C32.9154 256.791 265.955 294.004 411.478 285.499C598.959 274.544 901.476 230.265 1102.39 166.1C1325.94 101.928 1422.19 111.89 1440 116.463",
    stroke: "#E6E6E6",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00683594 251.263C41.1434 270.522 259.452 299.589 411.281 289.206C615.554 275.232 920.162 227.944 1103.09 176.615C1314.3 125.285 1417.75 139.352 1440 145.081",
    stroke: "#E6E6E6",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00683594 261.139C49.3705 284.252 252.937 304.558 411.08 292.907C632.13 275.046 938.846 225.62 1103.78 187.121C1302.65 148.623 1413.29 166.815 1440 173.684",
    stroke: "#E6E6E6",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00683594 271.024C57.5976 297.99 246.433 310.211 410.885 296.616C648.724 275.78 957.533 223.303 1104.47 197.636C1291.01 171.97 1408.84 194.286 1440 202.304",
    stroke: "#E6E6E6",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00878906 280.9C65.8267 311.712 239.929 315.852 410.686 300.319C665.317 276.503 976.222 220.972 1105.16 208.143C1279.37 195.308 1404.39 221.751 1440 230.916",
    stroke: "#E6E6E6",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00878906 290.778C187.558 378.58 922.524 218.653 1105.86 218.653C1267.73 218.653 1399.94 249.217 1440 259.526",
    stroke: "#E6E6E6",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1439.99 428.875H0",
    stroke: "#E6E6E6",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00390625 201.864C0.00390625 201.864 291.963 270.67 412.269 270.67C532.575 270.67 826.733 239.543 1099.62 124.047C1372.5 8.55158 1439.99 2 1439.99 2",
    stroke: "#E6E6E6",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.536 231.006H134.559C242.817 234.319 437.162 237.977 568.522 227.26C759.247 211.699 845.076 171.56 910.361 171.56C925.245 171.86 940.111 173.807 954.893 177.391",
    stroke: "#E6E6E6",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.258 234.168H292.275C329.72 230.33 379.349 224.922 397.596 221.524C428.404 215.783 460.681 208.418 493.695 208.418C526.709 208.418 557.513 210.059 633.803 194.495C704.055 180.164 701.528 172.088 818.679 186.248H818.691",
    stroke: "#E6E6E6",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00683594 203.155L3.46395 202.671H3.46958C29.0644 199.152 92.4207 191.219 143.787 191.219C209.801 191.219 301.502 201.042 324.236 201.042C346.97 201.042 366.788 193.677 396.862 193.677C479.018 193.677 470.951 182.196 553.109 182.196C598.294 182.196 628.173 186.162 655.795 189.732",
    stroke: "#E6E6E6",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00683594 416.303C60.5575 409.413 332.131 402.125 433.805 376.201C573.548 340.568 752.049 292.412 956.945 292.412C1161.84 292.412 1280.66 383.225 1439.99 343.284",
    stroke: "#E6E6E6",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00878906 290.778C187.558 378.58 922.524 218.653 1105.86 218.653C1267.73 218.653 1399.94 249.217 1440 259.526",
    stroke: "#E6E6E6",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground);
export default __webpack_public_path__ + "static/media/background.4471a617f37351a4c5d891ef30bb5a58.svg";
export { ForwardRef as ReactComponent };